import React from 'react';

const ShootingStarIcon = () => {
	return (
		<div className={'shooting-star'}>
			{/* eslint-disable max-len */}
			<svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36' fill='none'>
				<g>
					<path d='M36 32C36 34.209 34.209 36 32 36H4C1.791 36 0 34.209 0 32V4C0 1.791 1.791 0 4 0H32C34.209 0 36 1.791 36 4V32Z' fill='#226699'/>
					<path d='M11 8.99999C11 8.99999 18.29 4.44299 32 4.03099C32.652 4.01099 34 3.99999 34 4.99999C28 14 25 28 25 28L11 8.99999Z' fill='#F4900C'/>
					<path d='M12 16C12 16 24 5.00001 32 4.03101C32.647 3.95201 34 4.00001 34 5.00001C27 9.00001 22 24 22 24L12 16Z' fill='#FFAC33'/>
					<path d='M15.156 12.438C15.982 13.165 17.544 13.602 18.627 13.41L23.519 12.544C24.603 12.352 25.132 13.022 24.697 14.032L22.729 18.595C22.293 19.605 22.36 21.225 22.877 22.197L25.212 26.581C25.73 27.553 25.256 28.263 24.161 28.161L19.214 27.698C18.119 27.596 16.598 28.16 15.835 28.952L12.385 32.529C11.622 33.321 10.8 33.091 10.558 32.017L9.469 27.17C9.228 26.097 8.221 24.825 7.232 24.343L2.765 22.168C1.776 21.687 1.741 20.833 2.687 20.272L6.961 17.738C7.907 17.177 8.806 15.827 8.958 14.737L9.647 9.817C9.799 8.727 10.6 8.43 11.426 9.157L15.156 12.438Z' fill='#FFD983'/>
				</g>
			</svg>
			{/* eslint-enable max-len */}
		</div>
	);
};

export default ShootingStarIcon;
